import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = (withClear) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        background: colorsPalette.whiteSecondary,
        borderRadius: '999em',
        height: 60,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: withClear ? 30 : 25,
        paddingRight: 9,
        maxWidth: '100%',

        [theme.breakpoints.up('sm')]: {
          width: 600,
        },
      },
      input: {
        flex: 1,
        fontSize: 18,
        transition: 'margin-left, .2s',
        '& input::placeholder': {
          color: colorsPalette.white,
        },
        '&.active': {
          marginLeft: 24,
        },
      },
      searchIcon: {
        flex: 0,
        '& svg': {
          widht: 18,
          height: 18,
        },
      },
      closeIconWrapper: {
        position: 'absolute',
        left: 9,

        '& svg': {
          width: 17.8,
          height: 17.8,
        },
      },
    }),
  );

export default useStyles;
